/**
 * Конфигурация документов.
 * DocumentsOperations — все типы операций (include: true — показываются в меню).
 * DocumentsData — конфиг для каждого редактируемого типа документа:
 *   mainFilters — фильтры списка, mainColumns — колонки списка,
 *   modalData — поля шапки документа, modalColumns — колонки позиций,
 *   bottomRow/modalBottomRow — итоговые строки,
 *   shouldCheck2Stores — требуются оба склада (перемещение).
 */

export const DOC_FILTERS = {
  dateFrom: "dateFrom",
  dateTo: "dateTo",
  search: "search",
  store: "store",
  store2: "store2",
};

export const DOC_FIELD_TYPES = {
  textPointer: "textPointer",
  store: "store",
  store2: "store2",
  date: "date",
  time: "time",
  priceupdated: "priceupdated",
  comment: "comment",
};

export const DocumentsOperations = [
  { id: "1", name: "Продажи", include: true },
  { id: "2", name: "Возврата", include: true },
  { id: "3", name: "Списания", include: true },
  { id: "4", name: "Уценки", include: true },
  { id: "5", name: "Поступления", include: true },
  { id: "6", name: "Перемещения", include: true },
  { id: "7", name: "Возврата поставщику", include: true },
  { id: "8", name: "Инвентаризации", include: true },
  { id: "9", name: "Оприходования", include: true },
  { id: "62", name: "Перемещения (приход)" },
  { id: "41", name: "Переоценки (приход)" },
  { id: "10", name: "Приходного ордера" },
  { id: "11", name: "Расходного ордера" },
  { id: "12", name: "Установки цен" },
  { id: "13", name: "Собранный букет" },
  { id: "131", name: "Комплектация (приход)" },
  { id: "14", name: "Перемещение денег" },
  { id: "141", name: "Перемещение денег (приход)" },
  { id: "132", name: "Закрытые букеты" },
  { id: "133", name: "Букет в счете" },
  { id: "16", name: "Перемещение букетов" },
  { id: "134", name: "Перемещеный букет" },
  { id: "135", name: "Отправленный букет" },
  { id: "136", name: "Полученные букеты" },
  { id: "501", name: "Удаленный чек продажи" },
  { id: "502", name: "Удаленный чек возврата" },
  { id: "503", name: "Удаленный чек списания" },
  { id: "513", name: "Удаленный букет" },
  { id: "137", name: "Списанный букет" },
  { id: "17", name: "Платежное поручение входящее" },
  { id: "18", name: "Платежное поручение входящее" },
  { id: "19", name: "Счет покупателю" },
  { id: "20", name: "Заказ поставщику" },
  { id: "21", name: "Заказ на склад" },
  { id: "140", name: "Перемещенный заказ" },
  { id: "22", name: "Инвойс" },
  { id: "23", name: "Акт сверки" },
];

const sum = (rows, field) =>
  rows.reduce((acc, row) => acc + (Number(row[field]) || 0), 0);

const totalBottomRow = ({ documentsToDraw = [] }) => ({
  docid: -1,
  isConducted: -1,
  total: sum(documentsToDraw, "total").toFixed(2),
});

const noTotalBottomRow = ({ documentsToDraw = [] }) => ({
  docid: -1,
  isConducted: -1,
});

const itemsAmountTotalRow = ({ filteredDocItems = [] }) => ({
  docitemid: -1,
  index: filteredDocItems.length,
  amount: sum(filteredDocItems, "amount"),
  total: sum(filteredDocItems, "total").toFixed(2),
});

const itemsAmountRow = ({ filteredDocItems = [] }) => ({
  docitemid: -1,
  index: filteredDocItems.length,
  amount: sum(filteredDocItems, "amount"),
});

const inventoryBottomRow = ({ filteredDocItems = [] }) => ({
  docitemid: -1,
  index: filteredDocItems.length,
  realamount: sum(filteredDocItems, "realamount"),
  amount: sum(filteredDocItems, "amount"),
  difference:
    sum(filteredDocItems, "amount") - sum(filteredDocItems, "realamount"),
});

const BASE_FILTERS = [
  DOC_FILTERS.dateFrom,
  DOC_FILTERS.dateTo,
  DOC_FILTERS.store,
  DOC_FILTERS.search,
];

const conductedCol = { headerName: "Проведён", field: "isConducted", width: 110 };
const numberCol = { headerName: "Номер", field: "number", width: 120 };
const creationTimeCol = { headerName: "Дата документа", field: "creationTime", flex: 1, minWidth: 170 };
const totalCol = { headerName: "Сумма", field: "total", width: 130 };
const stockCol = { headerName: "Склад", field: "stock", flex: 1, minWidth: 140 };
const commentCol = { headerName: "Комментарий", field: "comment", flex: 1, minWidth: 160 };

const MAIN_COLUMNS_WITH_TOTAL = [
  conductedCol,
  numberCol,
  creationTimeCol,
  totalCol,
  stockCol,
  commentCol,
];

const MAIN_COLUMNS_NO_TOTAL = [
  conductedCol,
  numberCol,
  creationTimeCol,
  stockCol,
  commentCol,
];

const BASE_MODAL_DATA = [
  { name: "№ документа:", type: DOC_FIELD_TYPES.textPointer, field: "docid" },
  { name: "Склад", type: DOC_FIELD_TYPES.store },
  { name: "Дата", type: DOC_FIELD_TYPES.date },
  { name: "Время", type: DOC_FIELD_TYPES.time },
  { name: "Комментарий", type: DOC_FIELD_TYPES.comment },
];

const indexCol = { headerName: "№", field: "index", width: 60 };
const itemCol = { headerName: "Товар", field: "item", width: 190 };
const itemCodeCol = { headerName: "Артикул", field: "itemcode", width: 90 };
const measureCol = { headerName: "Ед. изм.", field: "measure", width: 90 };
const amountCol = { headerName: "Кол-во", field: "amount", width: 90 };
const priceCol = { headerName: "Цена, ₽", field: "price", width: 110 };
const totalItemCol = { headerName: "Итого, ₽", field: "total", width: 110 };

export const DocumentsData = {
  1: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_WITH_TOTAL,
    modalData: BASE_MODAL_DATA,
    modalColumns: [
      indexCol,
      itemCol,
      itemCodeCol,
      measureCol,
      amountCol,
      priceCol,
      totalItemCol,
      { headerName: "Скидка, ₽", field: "discountsum", width: 110 },
      { headerName: "Скидка клиента, ₽", field: "clientdiscountsum", width: 140 },
      { headerName: "Комментарий", field: "itemcomment", width: 220 },
    ],
    bottomRow: totalBottomRow,
    modalBottomRow: itemsAmountTotalRow,
  },
  2: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_WITH_TOTAL,
    modalData: BASE_MODAL_DATA,
    modalColumns: [
      indexCol,
      itemCol,
      measureCol,
      amountCol,
      priceCol,
      totalItemCol,
    ],
    bottomRow: totalBottomRow,
    modalBottomRow: itemsAmountTotalRow,
  },
  3: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_NO_TOTAL,
    modalData: BASE_MODAL_DATA,
    modalColumns: [indexCol, itemCol, measureCol, amountCol],
    bottomRow: noTotalBottomRow,
    modalBottomRow: itemsAmountRow,
  },
  4: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_NO_TOTAL,
    modalData: BASE_MODAL_DATA,
    modalColumns: [
      indexCol,
      { headerName: "Из товара", field: "item", width: 160 },
      measureCol,
      amountCol,
      { headerName: "В товар", field: "item2", width: 160 },
      { headerName: "Ед. изм.", field: "measure2", width: 90 },
    ],
    bottomRow: noTotalBottomRow,
    modalBottomRow: itemsAmountRow,
  },
  5: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_WITH_TOTAL,
    modalData: [
      { name: "№ документа:", type: DOC_FIELD_TYPES.textPointer, field: "docid" },
      { name: "Склад", type: DOC_FIELD_TYPES.store },
      { name: "Дата", type: DOC_FIELD_TYPES.date },
      { name: "Время", type: DOC_FIELD_TYPES.time },
      { name: "Не изменять продажные цены", type: DOC_FIELD_TYPES.priceupdated },
      { name: "Комментарий", type: DOC_FIELD_TYPES.comment },
    ],
    modalColumns: [
      indexCol,
      itemCol,
      measureCol,
      amountCol,
      priceCol,
      totalItemCol,
      { headerName: "Прайслист", field: "pricelist", width: 120 },
      { headerName: "Пр. цена", field: "frontprice", width: 100 },
      { headerName: "% наценки", field: "salepercent", width: 100 },
    ],
    bottomRow: totalBottomRow,
    modalBottomRow: itemsAmountTotalRow,
  },
  6: {
    mainFilters: [
      DOC_FILTERS.dateFrom,
      DOC_FILTERS.dateTo,
      DOC_FILTERS.store,
      DOC_FILTERS.store2,
      DOC_FILTERS.search,
    ],
    mainColumns: [
      conductedCol,
      numberCol,
      creationTimeCol,
      stockCol,
      { headerName: "Склад-получатель", field: "stock2", flex: 1, minWidth: 150 },
      commentCol,
    ],
    modalData: [
      { name: "№ документа:", type: DOC_FIELD_TYPES.textPointer, field: "docid" },
      { name: "Склад", type: DOC_FIELD_TYPES.store },
      { name: "Склад-получатель", type: DOC_FIELD_TYPES.store2 },
      { name: "Дата", type: DOC_FIELD_TYPES.date },
      { name: "Время", type: DOC_FIELD_TYPES.time },
      { name: "Комментарий", type: DOC_FIELD_TYPES.comment },
    ],
    modalColumns: [indexCol, itemCol, itemCodeCol, measureCol, amountCol],
    bottomRow: noTotalBottomRow,
    modalBottomRow: itemsAmountRow,
    shouldCheck2Stores: true,
  },
  7: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_WITH_TOTAL,
    modalData: BASE_MODAL_DATA,
    modalColumns: [
      indexCol,
      itemCol,
      measureCol,
      amountCol,
      priceCol,
      totalItemCol,
    ],
    bottomRow: totalBottomRow,
    modalBottomRow: itemsAmountTotalRow,
  },
  8: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_NO_TOTAL,
    modalData: BASE_MODAL_DATA,
    modalColumns: [
      indexCol,
      itemCol,
      itemCodeCol,
      measureCol,
      { headerName: "Кол-во учёт", field: "realamount", width: 110 },
      { headerName: "Кол-во факт + букет", field: "amount", width: 160 },
      { headerName: "Расхождение", field: "difference", width: 120 },
    ],
    bottomRow: noTotalBottomRow,
    modalBottomRow: inventoryBottomRow,
  },
  9: {
    mainFilters: BASE_FILTERS,
    mainColumns: MAIN_COLUMNS_WITH_TOTAL,
    modalData: BASE_MODAL_DATA,
    modalColumns: [
      indexCol,
      itemCol,
      measureCol,
      amountCol,
      priceCol,
      totalItemCol,
    ],
    bottomRow: totalBottomRow,
    modalBottomRow: itemsAmountTotalRow,
  },
};
